import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import marker from './john-lewis-map-pin.svg';

import styles from './GoogleMap.scss';
import { serviceApi } from '~/api';
import { Media } from '~/components/media/Media';

export class GoogleMap extends PureComponent {
  googleMapRef = React.createRef();

  isWideScreen = Media.greaterThan(window.innerWidth, Media.BREAKPOINTS.SM);

  componentDidMount() {
    this.fetchMapsApi().then(this.createScript).then(this.appendScript).then(this.drawMap);
  }

  fetchMapsApi = () =>
    serviceApi
      .fetch('maps-api', {
        headers: {
          Accept: 'application/octet-stream; charset=UTF-8',
          'Content-Type': 'text/javascript; charset=UTF-8',
        },
      })
      .then((res) => res.blob())
      .then(this.convertBlobToFile);

  createScript = (src) => {
    const script = document.createElement('script');
    script.src = src;

    return script;
  };

  appendScript = (script, container = document.body) =>
    new Promise((resolve) => {
      container.appendChild(script);
      script.addEventListener('load', resolve);
    });

  drawMap = () => {
    this.googleMapRef = this.createGoogleMap();
    this.marker = this.createMarker();
  };

  convertBlobToFile = (blob) => URL.createObjectURL(blob);

  createGoogleMap = () => {
    const {
      location: { latitude: lat, longitude: lng },
    } = this.props;

    return new window.google.maps.Map(this.googleMapRef.current, {
      zoom: 16,
      center: { lat, lng },
      disableDefaultUI: true,
      zoomControl: this.isWideScreen,
      scaleControl: true,
    });
  };

  createMarker = () => {
    const {
      location: { latitude: lat, longitude: lng },
      storeName,
    } = this.props;

    return new window.google.maps.Marker({
      position: { lat, lng },
      map: this.googleMapRef,
      title: storeName,
      icon: {
        url: marker,
        scaledSize: new window.google.maps.Size(58, 70),
      },
      optimized: false,
    });
  };

  render() {
    return <div id="google-map" ref={this.googleMapRef} className={styles.GoogleMap} />;
  }
}

GoogleMap.propTypes = {
  location: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
  storeName: PropTypes.string,
};

GoogleMap.defaultProps = {
  storeName: 'John Lewis',
};
